interface PillToggleProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  "aria-label"?: string;
}

export function PillToggle({ checked, onChange, "aria-label": ariaLabel }: PillToggleProps) {
  return (
    <label
      className="relative cursor-pointer shrink-0"
      style={{ width: 40, height: 22, display: "inline-block" }}
    >
      <input
        type="checkbox"
        className="sr-only peer"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        aria-label={ariaLabel}
      />
      <div className="absolute inset-0 rounded-full bg-smoke peer-checked:bg-dark-dust transition-colors duration-200" />
      <div
        className="absolute rounded-full bg-white transition-transform duration-200 peer-checked:translate-x-4.5"
        style={{
          width: 16,
          height: 16,
          left: 3,
          bottom: 3,
          boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
        }}
      />
    </label>
  );
}
